module.exports = __webpack_public_path__ + "static/media/OW5@2x.8f583379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OW/OW5@2x.png
// module id = 725
// module chunks = 0